export default "__VITE_PUBLIC_ASSET__a543258b__"